module.exports = __webpack_public_path__ + "img/facilityInfo_3_1.f29025c2.jpg";